import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import request from "../../Apis/request";
import { BaseURL, uniqueToken } from "../../api/DataApis";
import axios from "axios";
import Select from 'react-select';


function Add() {
  document.title = "Users | Add";
  let navigate = useNavigate();


  const handleCountryChange = (selectedOption) => {
    // If no option is selected, reset selected country and state
    if (!selectedOption) {
      setSelectedCountry("");
      setSelectedState("");
    } else {
      // Update selectedCountry with the chosen option
      setSelectedCountry({ _id: selectedOption._id, id: selectedOption.value });
      setSelectedState(""); // Reset state when a new country is selected
    }
  };
  
  
    
  const handleStateChange = (selectedOption) => {
    if (selectedOption) {
      // Set the selected state if an option is chosen
      setSelectedState({ _id: selectedOption._id, id: selectedOption.value });
    } else {
      // Clear the selected state if no option is selected (cleared)
      setSelectedState("");
    }
  };
  
  
  const handleCityChange = (selectedOption) => {
    setSelectedCity(selectedOption ? selectedOption.value : "");
  };

  
  

  // Destructure the data passed from the previous component
  // const UserEditData = location?.state?.UserEditData;

  // Log to ensure StationEditData is availabl

  // State variables
  const [Name, setName] = useState("");
  const [selectedStatusType, setSelectedStatusType] = useState("");
  const [Mobile, setMobile] = useState("");
  const [Email, setEmail] = useState([]);
  const [VehicleNumber, setVehicleNumber] = useState([]);
  const [selectedParent, setselectedParent] = useState([]);
  const [userType, setUserType] = useState([]);
  const [LongitudePoints, setLongitudePoints] = useState("");
  const [Address, setAddress] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState('');
  const [selectedState, setSelectedState] = useState('');
  const [selectedCity, setSelectedCity] = useState('');
  const [selectdStation, setselectedstation] =  useState('');
  const [StationData, setStationData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [VendorAmount, setVendorAmount] = useState('');

const handlevendorAmount = (e) => {
  setVendorAmount(e.target.value);
}

  const FetchStationsData = async () => {
    setLoading(true);
    const url = `${BaseURL}/station`;

    try {
      const res = await axios({
        url: url,
        method: "GET",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`,
        },
      });
      if (res && res.data.data) {
        setStationData(res.data.data);
        
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    FetchStationsData(); // Pass current page and search query to the fetch function
  }, []); 

  const handleStationID = (e) => {
    setselectedstation(e.target.value);
  }

  const countryOptions = countries.map(country => ({
    value: country.id,
    label: country.name,
    _id: country._id,
  }));

  const stateOptions = states.map((state) => ({
    value: state.id,
    label: state.name,
    _id: state._id
  }));

  const cityOptions = cities.map((city) => ({
    value: city._id,
    label: city.name,
  }));
  

  // Populate form fields with existing data on load


  // Handlers for form fields
  const handleName = (e) => setName(e.target.value);
  const handleFileChange = (e) => setSelectedFile(e.target.files[0]);
  const handleAddressChange = (e) => setAddress(e.target.value);
  const handleMobileChange = (e) => setMobile(e.target.value);
  const handleUserTypeChange = (e) => setUserType(e.target.value);
  const handleStatusType = (e) => setSelectedStatusType(e.target.value);
  const handleParentType = (e) => setselectedParent(e.target.value);
  const handlevehicleNumber = (e) => setVehicleNumber(e.target.value);
  const handleEmailChange = (e) => setEmail(e.target.value);
  

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axios.get(`${BaseURL}/settings/countries`, {
          headers: {
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
        setCountries(response.data.data);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchCountries();
  }, []);

  useEffect(() => {
    if (selectedCountry.id) {
      const fetchStates = async () => {
        try {
          const response = await axios.get(`${BaseURL}/settings/states/${selectedCountry.id}`, {
            headers: {
              Authorization: `Bearer ${uniqueToken}`,
            },
          });
          setStates(response.data.data.data);
          setCities([]);
        } catch (error) {
          console.error("Error fetching states:", error);
        }
      };

      fetchStates();
    }
  }, [selectedCountry.id]);
  console.log("selectedState.id", selectedState.id);

  const fetchCities = async () => {
    if (selectedState.id) {
      try {
        const response = await axios.get(`${BaseURL}/settings/cities/${selectedState.id}`, {
          headers: {
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
        console.log("Cities API Response:", response.data); 
        if (response.data && response.data.data) {
          setCities(response.data.data.data);
        } else {
          console.warn("No cities data found in response:", response);
          setCities([]); // Clear the cities if response is empty
        }
      } catch (error) {
        console.error("Error fetching cities:", error);
        setCities([]); // Clear the cities in case of error
      }
    }
  };
  useEffect(() => {
    fetchCities(); // Ensure this function is called when selectedState.id changes
  }, [selectedState.id]);





  // Function to handle the update request
  const AddUser = async () => {
    // Show loader before API call
    Swal.fire({
      title: 'Adding User...',
      text: 'Please wait',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  
    // Create a new FormData object
    let formData = new FormData();
    formData.append("name", Name);
    formData.append("address", Address);
    formData.append("mobile", Mobile);
    formData.append("email", Email);
    // formData.append("status", selectedStatusType);
    formData.append("userType", "Normal User");
    // formData.append("countryId", selectedCountry._id);
    // formData.append("stateId", selectedState._id);
    // formData.append("cityId", selectedCity);
    if (selectedCountry?._id) {
      formData.append("countryId", selectedCountry._id);
    }
    
    if (selectedState?._id) {
      formData.append("stateId", selectedState._id);
    }
    
    if (selectedCity) {
      formData.append("cityId", selectedCity);
    }
  
    if (selectedFile) {
      formData.append("profile_image", selectedFile);
    };
    if(VehicleNumber) {
    formData.append("vehicle_number", VehicleNumber);
    }
    if (selectdStation) {
      formData.append("station_id", selectdStation);
    }
 
    try {
      // Make the API request
      let response = await axios.post(
        `${BaseURL}/user/register`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${uniqueToken}`,
            // 'Content-Type' is automatically set by axios when using FormData
          },
        }
      );
  
      // Hide the loader
      Swal.close();
  
      // Handle the response
      if (response.data.statusCode === 200) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "User updated successfully...",
          showConfirmButton: false,
          timer: 1500,
        });
        navigate(`/usermanagement/users`);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: `Failed to update station. Status: ${response.data.statusCode}`,
        });
      }
    } catch (error) {
      // Hide the loader
      Swal.close();
  
      console.error("Error in AddUser:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "An unexpected error occurred.",
      });
    }
  };
  
console.log("StationData---", StationData);
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <h1 className="page-title"></h1>
              <div className="portlet light bordered">
                <div className="portlet-title row">
                  <div className="caption font-dark col-md-10">
                    <h4 className="caption-subject bold uppercase mx-3">
                      Add Users
                    </h4>
                  </div>
                  <div className="caption font-dark col-md-2">
                    <h5 className="caption-subject bold uppercase mx-3">
                      <button className="btn btn-success" onClick={() => navigate(-1)}>
                        Back
                      </button>
                    </h5>
                  </div>
                </div>
                <div className="portlet-body mx-3">
                  <hr />
                  <div className="row">
                    <div className="col-sm-12">
                      <form
                        className="form-horizontal"
                        encType="multipart/form-data"
                        role="form"
                        method="post"
                        style={{ marginTop: "-20px" }}
                      >
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="name_id" className="col-sm-2 control-label">
                            Name
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleName}
                                value={Name}
                                className="form-control"
                                id="name_id"
                                name="station_name"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>

                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="latitude_id" className="col-sm-2 control-label">
                              Mobile
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleMobileChange}
                                className="form-control"
                                id="latitude_id"
                                name="latitude"
                                value={Mobile}
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>

                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="longitude_id" className="col-sm-2 control-label">
                              Enter Email
                            </label>
                            <div className="col-sm-6">
                              <input
                              type="email"
                                onChange={handleEmailChange}
                                className="form-control"
                                id="email"
                                name="email"
                                value={Email}
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>

                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="longitude_id" className="col-sm-2 control-label">
                              Enter Vehicle Number
                            </label>
                            <div className="col-sm-6">
                              <input
                              type="vehilcle_number"
                                onChange={handlevehicleNumber}
                                className="form-control"
                                id="vehicle_number"
                                name="Vehicle_Number"
                              
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>

                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="longitude_id" className="col-sm-2 control-label">
                              Station Name
                            </label>
                            <div className="col-sm-6">
                              <select
                              type="station_id"
                                onChange={handleStationID}
                                className="form-control"
                                id="station_id"
                                name="station_id"
                              
                              >
                                <option value="">Select Station</option>
                                {StationData?.map((item) => {
                                  return (
                                    <option
                                      key={item?._id}
                                      value={item?._id}
                                    >
                                      {item?.station_name}
                                    </option>
                                  );
                                })}
                                </select>
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                    
                   
                        <div className="form-group">
                        <div className="row">
                          <label htmlFor="country_id" className="col-sm-2 control-label">Select Country</label>
                          <div className="col-sm-6">
                          <Select
      options={countryOptions}
      onChange={handleCountryChange}
      value={countryOptions.find(option => option.value === selectedCountry.id) || null}
      placeholder="Country"
      isClearable
    
      styles={{
        control: (base) => ({
          ...base,
          height: '38px', 
          width: '100%', // Make width responsive
          boxShadow: 'none',
          minWidth: '0', // Ensures it can shrink below 165px if needed
          flex: 1, // Allow select to grow and shrink
        }),
      }}
    />
                          </div>
                          <span className="col-sm-4 control-label"></span>
                        </div>
                      </div>

                      <div className="form-group">
                        <div className="row">
                          <label htmlFor="state_id" className="col-sm-2 control-label">Select State</label>
                          <div className="col-sm-6">
                          <Select
      options={stateOptions}
      onChange={(selectedOption) => {
        if (selectedOption) {
          setSelectedState({ _id: selectedOption._id, id: selectedOption.value });
        } else {
          setSelectedState(""); // Clear selection if option is cleared
        }
      }}
      placeholder="State"
      isClearable
  
      styles={{
        control: (base) => ({
          ...base,
          height: '38px',
          width: '100%', // Make width responsive
          minWidth: '150px',
          flex : 1
        }),
      }}
    />
                          </div>
                          <span className="col-sm-4 control-label"></span>
                        </div>
                      </div>

                      <div className="form-group">
                        <div className="row">
                          <label htmlFor="city_id" className="col-sm-2 control-label">Select City</label>
                          <div className="col-sm-6">
                          <Select
            value={cityOptions.find((option) => option.value === selectedCity) || null}
            onChange={handleCityChange}
            options={cityOptions}
            placeholder="City"
            isClearable
            styles={{
              control: (base) => ({
                ...base,
                height: '38px',
                width: '100%', // Make width responsive
                boxShadow: 'none',
                minWidth: '150px', // Ensures it can shrink below 150px if needed
                flex: 1, // Allow select to grow and shrink
              }),
            }}
          />
                          </div>
                          <span className="col-sm-4 control-label"></span>
                        </div>
                      </div>

                       
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Address
                            </label>
                            <div className="col-sm-6">
                              <textarea
                                onChange={handleAddressChange}
                                value={Address}
                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>

                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="file_id" className="col-sm-2 control-label">
                              Image
                            </label>
                            <div className="col-sm-6">
                              <input
                                type="file"
                                onChange={handleFileChange}
                                className="form-control"
                                id="file_id"
                                name="user_image"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>

                        {/* <div className="form-group">
                          <div className="row">
                            <label htmlFor="statusType" className="col-sm-2 control-label">
                              Status
                            </label>
                            <div className="col-sm-6">
                              <select
                                onChange={handleStatusType}
                                value={selectedStatusType}
                                type="text"
                                className="form-control"
                                id="statusType"
                                name="statusType"
                              >
                                <option value="0">Select Status</option>
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>
                              </select>
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div> */}


                        {/* <div className="form-group">
                          <div className="row">
                            <label htmlFor="statusType" className="col-sm-2 control-label">
                              Select Parent
                            </label>
                            <div className="col-sm-6">
                              <select
                                onChange={handleParentType}
                                value={selectedParent}
                                type="text"
                                className="form-control"
                                id="statusType"
                                name="statusType"
                              >
                                <option value="0">Select Parent</option>
                                <option value="Anupam">Anupam</option>
                                <option value="Akash">Akash</option>
                              </select>
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div> */}
                  


                        <div className="form-group">
                          <div className="col-sm-offset-2 col-sm-8 add-class">
                            <input
                              type="button"
                              className="btn btn-success"
                              onClick={AddUser}
                              value="Add User"
                            />
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Add;
